/**
 * useTaskActions — Hook for task mutation actions
 *
 * Returns stable action references from the Zustand store.
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTaskStore } from '../store/taskStore';
import type { BackendTask } from '../types';

export function useTaskActions() {
  const cancelTask = useTaskStore((s) => s.cancelTask);
  const removeTask = useTaskStore((s) => s.removeTask);
  const deleteTasks = useTaskStore((s) => s.deleteTasks);
  const markViewed = useTaskStore((s) => s.markViewed);

  const navigate = useNavigate();

  const navigateToResult = useCallback(
    (task: BackendTask) => {
      if (task.targetEntityPath?.frontendUrl) {
        navigate(task.targetEntityPath.frontendUrl);
      }
    },
    [navigate]
  );

  return { cancelTask, removeTask, deleteTasks, markViewed, navigateToResult };
}
